export const postLoginPath = (user) => ["PLATFORM_SUPER_ADMIN", "PLATFORM_ENGINEERING_ADMIN"].includes(user?.platformRole) ? "/internal/platform-control" : "/dashboard";
